import { FunctionComponent, useState } from 'react'
import { useForm } from 'react-hook-form'
import { steps } from 'modules/onboarding'
import HttpClient from 'shared/httpClients/frotista.api'
import { useOnboardContext } from 'modules/onboarding/context'
import {
  Container,
  Header,
  Main,
  Typography,
  Action,
  Observation,
  Button,
  TextField,
  Error,
  Eye,
  EyeOff,
  IconButton,
} from './styles'
import { Onboard } from 'modules/onboarding/types/Onboard'

type TProps = {
  setSelectedStep?(step: number): void
}

type TFormData = {
  senha: string
  confirmarSenha: string
}

const api = new HttpClient().api()

const DefinicaoSenha: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  const STRONG_PASSWORD_PATTERN = /^(?=.*\d)(?=.*[A-Z])[0-9a-zA-Z$*&!.@#]{8,}$/

  const { state } = useOnboardContext()
  const [showSenha, setShowSenha] = useState<boolean>(false)
  const [showConfirmarSenha, setShowConfirmarSenha] = useState<boolean>(false)

  const [error, setError] = useState<string>('')

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TFormData>()

  const updateFrotista = async (data: Onboard): Promise<void> => {
    try {
      await api
        .put('/parceiros', data)
        .then(() => setSelectedStep(steps.Encerramento))
    } catch (err) {
      setError(err.message)
    }
  }

  const onSubmitHandle = async (data: TFormData) => {
    await updateFrotista({ ...state, senha: data.senha })
  }

  const IconShowSenha: FunctionComponent = () => {
    return !showSenha ? (
      <IconButton
        icon={Eye}
        variant="text"
        onClick={() => setShowSenha(!showSenha)}
      />
    ) : (
      <IconButton
        icon={EyeOff}
        variant="text"
        onClick={() => setShowSenha(!showSenha)}
      />
    )
  }
  const IconShowConfirmarSenha: FunctionComponent = () => {
    return !showConfirmarSenha ? (
      <IconButton
        icon={Eye}
        variant="text"
        onClick={() => setShowConfirmarSenha(!showConfirmarSenha)}
      />
    ) : (
      <IconButton
        icon={EyeOff}
        variant="text"
        onClick={() => setShowConfirmarSenha(!showConfirmarSenha)}
      />
    )
  }

  return (
    <Container>
      <Header />
      <Main>
        <Typography variant="p1" fontWeight="semibold">
          Crie a senha de acesso ao Tmov Parceiros
        </Typography>
        <form
          autoComplete="off"
          id="passForm"
          onSubmit={handleSubmit(onSubmitHandle)}
        >
          <TextField
            {...register('senha', {
              required: true,
              pattern: STRONG_PASSWORD_PATTERN,
            })}
            type={showSenha ? 'text' : 'password'}
            length={32}
            label="Senha"
            trailingIcon={IconShowSenha}
            error={errors.senha && true}
            supportingText={
              errors.senha && 'Senha não atende aos pré-requisitos'
            }
          />
          <TextField
            {...register('confirmarSenha', {
              required: true,
              validate: (value, formValues) => value === formValues.senha,
            })}
            type={showConfirmarSenha ? 'text' : 'password'}
            length={32}
            label="Confirmar senha"
            trailingIcon={IconShowConfirmarSenha}
            error={errors.confirmarSenha && true}
            supportingText={errors.confirmarSenha && 'Senhas não coincidem'}
          />
          <Error>{error}</Error>
        </form>
        <Observation>
          <Typography variant="p1" fontWeight="semibold">
            Sua senha deve conter
          </Typography>
          <li>Um número</li>
          <li>Uma letra maiúscula</li>
          <li>Minimo 8 digitos</li>
        </Observation>
      </Main>
      <Action>
        <Button
          type="button"
          variant="contained"
          size="lg"
          onClick={() => setSelectedStep(steps.Terms)}
        >
          Voltar
        </Button>
        <Button type="submit" variant="contained" size="lg" form="passForm">
          Próximo
        </Button>
      </Action>
    </Container>
  )
}

export default DefinicaoSenha
